export const permissions = {
  INVITATION_CREATE: "INVITATION_CREATE",
  USER_CREATE: "USER_CREATE",
  VIEW_BRANCH_USERS: "VIEW_BRANCH_USERS",
  MANAGE_BRANCH_USERS: "MANAGE_BRANCH_USERS",
  VIEW_USER_GROUPS: "VIEW_USER_GROUPS",
  VIEW_BRANCHES: "VIEW_BRANCHES",
  EDIT_BRANCHES: "EDIT_BRANCHES",
  ADD_BRANCHES: "ADD_BRANCHES",
  VIEW_TENANT: "VIEW_TENANT",
  EDIT_TENANT: "EDIT_TENANT",
  VIEW_TENANT_PRODUCTS: "VIEW_TENANT_PRODUCTS",
  VIEW_PRODUCT_PRICE: "VIEW_PRODUCT_PRICE",
  //PR permissions
  EDIT_DRAFT_PURCHASE_REQUEST: "EDIT_DRAFT_PURCHASE_REQUEST",
  VIEW_DRAFT_PURCHASE_REQUEST: "VIEW_DRAFT_PURCHASE_REQUEST",
  VIEW_PURCHASE_REQUEST: "VIEW_PURCHASE_REQUEST",
  //PO permissions
  EDIT_DRAFT_PURCHASE_ORDER: "EDIT_DRAFT_PURCHASE_ORDER",
  VIEW_DRAFT_PURCHASE_ORDER: "VIEW_DRAFT_PURCHASE_ORDER",
  VIEW_PURCHASE_ORDER: "VIEW_PURCHASE_ORDER",
};
